/* Antistatik · refonte v3.1, tâche E2 (23/10/2026) : pastilles cliquables des cartes produit.
   Un clic sur une pastille (snippets/ask-collection-coloris.liquid) met dans la carte la photo de la première variante de
   ce coloris et ajoute ?variant=… au lien de la carte. La fiche ne s'ouvre pas.
   Chargé par snippets/card-product.liquid (avec la première carte) et par sections/main-collection-product-grid.liquid.
   Un seul écouteur sur le document : il sert aussi aux cartes ajoutées après coup. Chargé deux fois, il ne fait rien la 2e. */
(function () {
  if (window.askCartesColoris) return;
  window.askCartesColoris = true;

  var LARGEURS = [180, 360, 540, 720, 1080];
  var largeur = function (url, w) {
    return /([?&])width=\d+/.test(url) ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url + (url.indexOf('?') < 0 ? '?' : '&') + 'width=' + w;
  };

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.ask-carte__pastille') : null;
    if (!b) return;
    e.preventDefault();
    var carte = b.closest('.ask-carte');
    if (!carte) return;
    var groupe = b.closest('[data-ask-coloris]');
    if (groupe) {
      groupe.querySelectorAll('.ask-carte__pastille[aria-pressed="true"]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
    }
    b.setAttribute('aria-pressed', 'true');

    // Lien de la carte (et du « +N ») vers ce coloris
    var id = b.value;
    if (id) {
      carte.querySelectorAll('.ask-carte__lien, .ask-carte__plus').forEach(function (a) {
        try {
          var u = new URL(a.getAttribute('href'), window.location.origin);
          u.searchParams.set('variant', id);
          a.setAttribute('href', u.pathname + u.search);
        } catch (err) { /* lien laissé tel quel */ }
      });
    }

    // Photo du coloris : chargée à part, puis échangée (pas d'image vide, pas de saut : le cadre garde son format 2:3)
    var img = carte.querySelector('.ask-carte__img > img');
    var src = b.getAttribute('data-img');
    if (!img || !src) return;
    var titre = carte.querySelector('.ask-carte__titre');
    var base = titre ? titre.textContent.replace(/\s+/g, ' ').trim() : (img.getAttribute('alt') || '');
    var nom = b.getAttribute('aria-label') || '';
    var srcset = LARGEURS.map(function (w) { return largeur(src, w) + ' ' + w + 'w'; }).join(', ');
    var jeton = String(Date.now());
    carte.setAttribute('data-ask-jeton', jeton);
    carte.classList.add('is-chargement');
    var pre = new Image();
    pre.sizes = img.getAttribute('sizes') || '';
    pre.srcset = srcset;
    pre.src = src;
    var poser = function () {
      if (carte.getAttribute('data-ask-jeton') !== jeton) return; // un autre clic est passé entre-temps
      img.removeAttribute('loading');
      img.setAttribute('srcset', srcset);
      img.setAttribute('src', src);
      img.setAttribute('alt', base + (nom ? ', coloris ' + nom : '')); // ex. « T-shirt homme classique, coloris Natural »
      carte.classList.remove('is-chargement');
    };
    if (pre.decode) { pre.decode().then(poser, poser); } else { pre.onload = poser; pre.onerror = poser; }
  });
})();
